import { BehaviorSubject } from 'rxjs';

export const sharedClipBoardContentsSubject$ = new BehaviorSubject<{
  type: string;
  data: any;
} | null>(null);
